module.exports = __webpack_public_path__ + "static/media/pencil.1379db4a.svg";